import { render, staticRenderFns } from "./navBar.vue?vue&type=template&id=45edc132&scoped=true"
import script from "./navBar.vue?vue&type=script&lang=js"
export * from "./navBar.vue?vue&type=script&lang=js"
import style0 from "./navBar.vue?vue&type=style&index=0&id=45edc132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45edc132",
  null
  
)

export default component.exports